var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-on-call.1184dab5.png","uri@2x": __webpack_public_path__ + "icon-on-call.63d4b53d.png","uri@3x": __webpack_public_path__ + "icon-on-call.eb41ce68.png",
    width: 20,
    height: 20
});